// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.side-drawer {
  position: absolute;
  left: -30vw;
  width: 30vw;
  height: 100vh;
  background-color: white;
  border-right: 1px solid #e0e0e0 !important;
}

.side-drawer__full-screen {
  position: fixed;
  /* Ensure it's relative to the viewport */
  top: 0;
  /* Start from the top */
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white;
  border-right: 1px solid #e0e0e0;
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./../common/src/Components/PreviewTemplateDrawer/SideDrawer.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,0CAAA;AACJ;;AAEA;EACI,eAAA;EAAiB,yCAAA;EACjB,MAAA;EAAiB,uBAAA;EACjB,OAAA;EACA,QAAA;EACA,SAAA;EACA,uBAAA;EACA,+BAAA;EACA,UAAA;AAGJ","sourcesContent":[".side-drawer {\n    position: absolute;\n    left:-30vw;\n    width:30vw;\n    height: 100vh;\n    background-color: white;\n    border-right: 1px solid #e0e0e0 !important;\n}\n\n.side-drawer__full-screen {\n    position: fixed; /* Ensure it's relative to the viewport */\n    top: 0;          /* Start from the top */\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: white;\n    border-right: 1px solid #e0e0e0;\n    z-index: 2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
